import { createContext, ReactNode, useContext, useState } from "react";

interface ExistingUserEmailContextType {
  existingUserEmail: string;
  setExistingUserEmail: (email: string) => void;
  clearExistingUserEmail: () => void;
}

export const ExistingUserEmailContext = createContext<
  ExistingUserEmailContextType | undefined
>(undefined);

export const useExistingUserEmail = (): ExistingUserEmailContextType => {
  const context = useContext(ExistingUserEmailContext);
  if (!context) {
    throw new Error(
      "useExistingUserEmail must be used within a ExistingUserEmailProvider"
    );
  }
  return context;
};

interface ExistingUserEmailProviderProps {
  children: ReactNode;
}

export const ExistingUserEmailProvider = ({
  children,
}: ExistingUserEmailProviderProps) => {
  const [existingUserEmail, setExistingUserEmail] = useState("");

  const clearExistingUserEmail = () => {
    setExistingUserEmail("");
  };

  return (
    <ExistingUserEmailContext.Provider
      value={{
        existingUserEmail,
        setExistingUserEmail,
        clearExistingUserEmail,
      }}
    >
      {children}
    </ExistingUserEmailContext.Provider>
  );
};
